import React, { useState, cloneElement } from "react";
import { Modal, ModalHeader, ModalBody } from "reactstrap";

/**
 * Wraps a chart Card component and adds a maximize button.
 * The child chart must accept a `heightOverride` prop.
 *
 * Usage:
 *   <ExpandableChart title="Ingresos y egresos">
 *     <IncomeChart docs={docs} prevDocs={prev} showMA={showMA} />
 *   </ExpandableChart>
 */
const EXPANDED_HEIGHT = 540;

const ExpandableChart = ({ title, children }) => {
  const [open, setOpen] = useState(false);

  return (
    <>
      <div style={{ position: "relative" }}>
        {children}
        <button
          onClick={() => setOpen(true)}
          title="Maximizar"
          className="btn btn-sm btn-light"
          style={{
            position: "absolute",
            bottom: 12,
            right: 12,
            zIndex: 5,
            padding: "2px 5px",
            opacity: 0.3,
            transition: "opacity 0.2s",
            lineHeight: 1,
          }}
          onMouseEnter={(e) => (e.currentTarget.style.opacity = 1)}
          onMouseLeave={(e) => (e.currentTarget.style.opacity = 0.4)}
        >
          <span className="material-symbols-rounded" style={{ fontSize: 16 }}>
            fullscreen
          </span>
        </button>
      </div>

      <Modal isOpen={open} toggle={() => setOpen(false)} size="xl" centered style={{ maxWidth: "95vw" }}>
        <ModalHeader toggle={() => setOpen(false)} className="py-2">
          {title || ""}
        </ModalHeader>
        <ModalBody style={{ padding: "0 8px 8px" }}>
          {open && cloneElement(children, { heightOverride: EXPANDED_HEIGHT })}
        </ModalBody>
      </Modal>
    </>
  );
};

export default ExpandableChart;
